import { shipmentConstants } from '../_constants'

const INITIAL_STATE = {
  shipments: [],
  shipmentsToAsign: [],
  shipmentsActual: [],
  shipmentsModifications: [],
  shipmentRelationChains: [],
  selectedShipmentRelationChain: null,
}

const shipmentReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case shipmentConstants.GET_ALL_SHIPMENTS:
      return Object.assign({}, state, {
        shipments: action.payload.shipments,
      })
    case shipmentConstants.GET_ALL_TO_ASIGN:
      return Object.assign({}, state, {
        shipmentsToAsign: action.payload.shipments,
      })
    case shipmentConstants.GET_ALL_ACTUALS:
      return Object.assign({}, state, {
        shipmentsActual: action.payload.shipments,
      })
    case shipmentConstants.GET_ALL_MODIFICATIONS:
      return Object.assign({}, state, {
        shipmentsModifications: action.payload.shipments,
      })
    case shipmentConstants.GET_ALL_RELATION_CHAINS:
      return Object.assign({}, state, {
        shipmentRelationChains: action.payload.chains,
      })
    case shipmentConstants.GET_RELATION_CHAIN:
      return Object.assign({}, state, {
        selectedShipmentRelationChain: action.payload.chain,
      })
    default:
      return state
  }
}

export default shipmentReducer
